var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"programme-icons"},[_c('span',{staticClass:"iconfont",class:_vm.icon}),_c('span',{staticClass:"text"},[_vm._t("text1")],2),_c('span',{staticClass:"text text2"},[_vm._t("text2")],2),_c('span',{staticClass:"line-span"})])}
var staticRenderFns = []

export { render, staticRenderFns }